export default "__VITE_ASSET__03b305a9__"